/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataSourcesStore } from '../store/data-sources.store';
import {LabelsTableComponent} from "@src/app/data-sources/components/labels-table/labels-table.component";

@Injectable({
  providedIn: 'root'
})
export class DataSourcesGuard {
  private store = inject(DataSourcesStore)

  canActivate(): boolean {
    this.store.getDataSources({
      pagination: this.store.pagination(),
      filter: this.store.filter(),
      sort: this.store.sort()
    })
    return true
  }

  canDeactivate(
    component: LabelsTableComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean {
    this.store.resetState()
    return true;
  }
}
